import React from "react";
import DevisForm from "../DevisForm";

const ContenuDynamiqueForm = () => {
  return (
    <div className="dynamic form">
      <div className="inner">
        <DevisForm />
      </div>
    </div>
  );
};

export default ContenuDynamiqueForm;
